'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileTaxesW9', cobCarrierProfileTaxesW9);

	cobCarrierProfileTaxesW9.$inject = [
		'sessionService', 'subjectObserverMessagesService', 'observerService',
		'carrierRegistrationService', '$timeout', '$location', '$stateParams',
		'SSN_PLACEHOLDER', 'EIN_PLACEHOLDER'
	];

	var sessionService,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		$timeout,
		$location,
		$stateParams,
		ssnPlaceholder,
		einPlaceholder;
	var subjectMessages, observerMessages;

	function cobCarrierProfileTaxesW9(_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$timeout_,
		_$location_,
		_$stateParams_,
		SSN_PLACEHOLDER,
		EIN_PLACEHOLDER) {
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		$timeout = _$timeout_;
		$location = _$location_;
		$stateParams = _$stateParams_;
		ssnPlaceholder = SSN_PLACEHOLDER;
		einPlaceholder = EIN_PLACEHOLDER;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileTaxesW9.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.ssnPlaceholder = ssnPlaceholder;
			scope.einPlaceholder = einPlaceholder;

			scope.carrierId = $stateParams.carrierId;
			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				loaded: false,
				isDirty: false,
				showSectionMessage: false,
				exemptionType: 0
			};

			scope.federalTypes = [
				{ key: '--', value: 'Select' },
				{ key: 'Individualsoleproprietor', value: 'Individual/Sole Proprietor or Single-Member LLC' },
				{ key: 'CCorporation', value: 'C Corporation' },
				{ key: 'SCorporation', value: 'S Corporation' },
				{ key: 'Partnership', value: 'Partnership' },
				{ key: 'Trustestate', value: 'Trust/Estate' },
				{ key: 'LLC_CCorporation', value: 'LLC taxed as C Corp' },
				{ key: 'LLC_SCorporation', value: 'LLC taxed as S Corp' },
				{ key: 'LLC_Partnership', value: 'LLC taxed as Partnership' },
				{ key: 'Other', value: 'Other' }
			];

			scope.exemptionTypes = [
				{ key: 0, value: '--' },
				{ key: 1, value: '1' },
				{ key: 2, value: '2' },
				{ key: 3, value: '3' },
				{ key: 4, value: '4' },
				{ key: 5, value: '5' },
				{ key: 6, value: '6' },
				{ key: 7, value: '7' },
				{ key: 8, value: '8' },
				{ key: 9, value: '9' },
				{ key: 10, value: '10' },
				{ key: 11, value: '11' },
				{ key: 12, value: '12' },
				{ key: 13, value: '13' }
			];

			scope.reportCodes = {
				'--': '--',
				'A': 'A',
				'B': 'B',
				'C': 'C',
				'D': 'D',
				'E': 'E',
				'F': 'F',
				'G': 'G',
				'H': 'H',
				'I': 'I',
				'J': 'J',
				'K': 'K',
				'L': 'L',
				'M': 'M'
			};

			scope.stateList = [
				{ key: '--', value: '--', country: 'USA' },
				{ key: 'AL', value: 'AL', country: 'USA' },
				{ key: 'AK', value: 'AK', country: 'USA' },
				{ key: 'AS', value: 'AS', country: 'USA' },
				{ key: 'AZ', value: 'AZ', country: 'USA' },
				{ key: 'AR', value: 'AR', country: 'USA' },
				{ key: 'CA', value: 'CA', country: 'USA' },
				{ key: 'CO', value: 'CO', country: 'USA' },
				{ key: 'CT', value: 'CT', country: 'USA' },
				{ key: 'DE', value: 'DE', country: 'USA' },
				{ key: 'DC', value: 'DC', country: 'USA' },
				{ key: 'FL', value: 'FL', country: 'USA' },
				{ key: 'GA', value: 'GA', country: 'USA' },
				{ key: 'GU', value: 'GU', country: 'USA' },
				{ key: 'HI', value: 'HI', country: 'USA' },
				{ key: 'ID', value: 'ID', country: 'USA' },
				{ key: 'IL', value: 'IL', country: 'USA' },
				{ key: 'IN', value: 'IN', country: 'USA' },
				{ key: 'IA', value: 'IA', country: 'USA' },
				{ key: 'KS', value: 'KS', country: 'USA' },
				{ key: 'KY', value: 'KY', country: 'USA' },
				{ key: 'LA', value: 'LA', country: 'USA' },
				{ key: 'ME', value: 'ME', country: 'USA' },
				{ key: 'MD', value: 'MD', country: 'USA' },
				{ key: 'MA', value: 'MA', country: 'USA' },
				{ key: 'MI', value: 'MI', country: 'USA' },
				{ key: 'MN', value: 'MN', country: 'USA' },
				{ key: 'MS', value: 'MS', country: 'USA' },
				{ key: 'MO', value: 'MO', country: 'USA' },
				{ key: 'MT', value: 'MT', country: 'USA' },
				{ key: 'NE', value: 'NE', country: 'USA' },
				{ key: 'NV', value: 'NV', country: 'USA' },
				{ key: 'NH', value: 'NH', country: 'USA' },
				{ key: 'NJ', value: 'NJ', country: 'USA' },
				{ key: 'NM', value: 'NM', country: 'USA' },
				{ key: 'NY', value: 'NY', country: 'USA' },
				{ key: 'NC', value: 'NC', country: 'USA' },
				{ key: 'ND', value: 'ND', country: 'USA' },
				{ key: 'OH', value: 'OH', country: 'USA' },
				{ key: 'OK', value: 'OK', country: 'USA' },
				{ key: 'OR', value: 'OR', country: 'USA' },
				{ key: 'PA', value: 'PA', country: 'USA' },
				{ key: 'PR', value: 'PR', country: 'USA' },
				{ key: 'RI', value: 'RI', country: 'USA' },
				{ key: 'SC', value: 'SC', country: 'USA' },
				{ key: 'SD', value: 'SD', country: 'USA' },
				{ key: 'TN', value: 'TN', country: 'USA' },
				{ key: 'TX', value: 'TX', country: 'USA' },
				{ key: 'UT', value: 'UT', country: 'USA' },
				{ key: 'VT', value: 'VT', country: 'USA' },
				{ key: 'VA', value: 'VA', country: 'USA' },
				{ key: 'VI', value: 'VI', country: 'USA' },
				{ key: 'WA', value: 'WA', country: 'USA' },
				{ key: 'WV', value: 'WV', country: 'USA' },
				{ key: 'WI', value: 'WI', country: 'USA' },
				{ key: 'WY', value: 'WY', country: 'USA' }
			];

			scope.validateName = validateName;
			scope.validateTaxClassification = validateTaxClassification;
			scope.validateStreetAddress = validateStreetAddress;
			scope.validateCityAddress = validateCityAddress;
			scope.validateStateAddress = validateStateAddress;
			scope.validatePostalCodeAddress = validatePostalCodeAddress;
			scope.validateFederalTypeOther = validateFederalTypeOther;
			scope.textFieldKeyDown = textFieldKeyDown;
			scope.validateTin = validateTin;
			scope.goToTab = goToTab;
			scope.onForceGo = onForceGo;
			scope.setIsDirty = setIsDirty;
			scope.parseInt = parseInt;

			registerObserverHandlers();
		}

		function loadData(data) {

			scope.m.loaded = true;
			scope.m.name = data.name;
			scope.m.businessName = data.businessName;
			scope.m.streetAddress = data.streetAddress;
			scope.m.cityAddress = data.cityAddress;
			scope.m.postalCodeAddress = data.postalCodeAddress;
			scope.m.stateAddress = data.stateAddress;
			scope.m.federalType = data.federalType;
			scope.m.federalTypeOther = data.federalTypeOther;
			scope.m.reportCode = data.reportCode;
			scope.m.eid = data.eid;
			scope.m.ssn = data.ssn;
            
			var navState = sessionService.getCarrierNavState();
			if (!scope.m.eid && !scope.m.ssn) {
				if (navState && navState.taxInfoComplete) {
					scope.m.eid = '*********';
					scope.m.ssn = '*********';
				}
			}
			if (!data.exemptionType) {
				scope.m.exemptionType = 0;
			} else {
				scope.m.exemptionType = data.exemptionType;
			}

			updateTaxStatus(data.taxStatus);
		}

		function updateTaxStatus(taxStatus) {
			var taxStatusDic = {
				'Valid': 'valid',
				'Pending': 'awaiting validation'
			};

			if(taxStatusDic[taxStatus]) {
				scope.m.taxStatusText = taxStatusDic[taxStatus];

				return;
			}

			scope.m.taxStatusText = 'invalid';
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_W9_LOADED, handler: loadData },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!
							confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}

					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function setIsDirty() {
			scope.m.isDirty = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function saveData(callback) {
			if (!scope.m.loaded)
				return;
			if (scope.m.isDirty) {
				if (formIsValid()) {
					var federalTaxType;
					var tin;
					if (scope.m.ssn) {
						federalTaxType = 'SSN';
						tin = scope.m.ssn;
					} else {
						federalTaxType = 'EID';
						tin = scope.m.eid;
					}

					carrierRegistrationService.updateW9TaxInformation(scope.m.name,
						scope.m.businessName,
						scope.m.federalType,
						scope.m.federalTypeOther,
						scope.m.exemptionType,
						scope.m.reportCode,
						scope.m.streetAddress,
						scope.m.cityAddress,
						scope.m.stateAddress,
						scope.m.postalCodeAddress,
						tin,
						federalTaxType,
						scope.carrierId)
						.then(function() {
							observerService
								.sendMessageToSubject(scope,
									subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
									'taxes');
							scope.m.isDirty = false;
							window.onbeforeunload = undefined;
							if (typeof (callback) === 'function')
								callback();
							else {
								observerService
									.sendMessageToSubject(scope,
										subjectMessages
											.COB_SUBJECT_CARRIER_PROFILE_TAX_RELOAD);
							}
						})
						.catch(function(e) {
							console.log(e);
						});

				} else {
					// invalid form
					scope.m.showSectionMessage = true;
					scope.pendingCallback = callback;

					$timeout(function() {
						scope.ux_requirement_hack_for_scrolling = true;
						$('.profile-tax')
							.animate({
								scrollTop: $('#error-summary').offset().top
							},
							200);
						setIsDirty();
					},
					1);
				}
			} else {
				scope.m.showSectionMessage = false;
				if (typeof (callback) === 'function')
					callback();
			}
		}

		function validateName() {
			if (!scope.m.name) {
				scope.m.nameError = 'Valid input is required';
			} else {
				scope.m.nameError = '';
			}
		}

		function validateTaxClassification() {
			if (scope.m.federalType === '--') {
				validateFederalTypeOther();
				scope.m.federalTypeError = 'Please select an option';
			} else {
				if (scope.m.federalType !== 'Other') {
					validateFederalTypeOther();
					scope.m.federalTypeOther = '';
				}
				scope.m.federalTypeError = '';
			}
		}

		function validateStreetAddress() {
			if (!scope.m.streetAddress) {
				scope.m.streetAddressError = 'Valid input is required';
			} else {
				scope.m.streetAddressError = '';
			}
		}

		function validateCityAddress() {
			if (!scope.m.cityAddress) {
				scope.m.cityAddressError = 'Valid input is required';
			} else {
				scope.m.cityAddressError = '';
			}
		}

		function validateStateAddress() {
			if (scope.m.stateAddress === '--') {
				scope.m.stateAddressError = 'Valid input is required';
			} else {
				scope.m.stateAddressError = '';
			}
		}

		function validatePostalCodeAddress() {
			var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(scope.m.postalCodeAddress);

			if (!isValidZip) {
				scope.m.postalCodeAddressError = 'Valid input is required';
			} else {
				scope.m.postalCodeAddressError = '';
			}
		}

		function validateSsn() {
			if (scope.m.ssn) {
				if (scope.m.ssn.toString().length !== 9) {
					scope.m.ssnError = 'Valid input is required';

					return;
				}
			}
			scope.m.ssnError = '';
		}

		function validateEid() {
			if (scope.m.eid) {
				if (scope.m.eid.toString().length !== 9) {
					scope.m.eidError = 'Valid input is required';

					return;
				}
			}
			scope.m.eidError = '';
		}

		function validateFederalTypeOther() {
			if (scope.m.federalType === 'Other' && !scope.m.federalTypeOther) {
				scope.m.federalTypeOtherError = 'Valid input is required';
			} else {
				scope.m.federalTypeOtherError = '';
			}
		}

		function validateTin() {
			if (scope.m.eid && scope.m.ssn) {
				scope.m.tinError = 'Only one TIN allowed';
				scope.m.eidError = '';
				scope.m.ssnError = '';
			} else if (!scope.m.eid && !scope.m.ssn) {
				scope.m.tinError = 'Valid input is required';
				scope.m.eidError = '';
				scope.m.ssnError = '';
			} else {
				scope.m.tinError = '';
				validateEid();
				validateSsn();
			}
		}

		function formIsValid() {
			validateName();
			validateTaxClassification();
			validateStreetAddress();
			validateStateAddress();
			validatePostalCodeAddress();
			validateTin();
			validateFederalTypeOther();

			if (!scope.m.nameError &&
                !scope.m.federalTypeError &&
                !scope.m.streetAddressError &&
                !scope.m.stateAddressError &&
                !scope.m.postalCodeAddressError &&
                !scope.m.ssnError &&
                !scope.m.eidError &&
                !scope.m.federalTypeOtherError &&
                !scope.m.tinError) {

				scope.m.showSectionMessage = false;

				return true;
			}

			scope.m.showSectionMessage = true;

			return false;
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function textFieldKeyDown(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			var isShift = !!event.shiftKey;

			if (isShift) {
				switch (charCode) {
				case 220: // | character
				case 222: // "
					event.preventDefault();
				}
			}
		}
	}

})();
